export const PAYSTACK_PUBLIC_KEY =
  "pk_test_4ef21dc07e29ed7fc321b546c93bbbfa05bb8a75";
